module.exports = __webpack_public_path__ + "static/media/grohe-logo.f3a0a375.png";